export const GET_AUCTION_DATA = 'GET_AUCTION_DATA';
export const GET_AUCTION_DATA_SUCCESS = 'GET_AUCTION_DATA_SUCCESS';
export const GET_AUCTION_DATA_FAILURE = 'GET_AUCTION_DATA_FAILURE';

export const GET_AUCTIONS_INFO = 'GET_AUCTIONS_INFO';
export const GET_AUCTIONS_INFO_SUCCESS = 'GET_AUCTIONS_INFO_SUCCESS';
export const GET_AUCTIONS_INFO_FAILURE = 'GET_AUCTIONS_INFO_FAILURE';
